/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'

type Props = {
  icon: React.ComponentType
  id: string
  isDisabled: boolean
  onClick: () => void
}

function ReveleerControlButton(
  props: Props
): JSX.Element {
  const {
    icon: Icon,
    id,
    isDisabled,
    onClick: onClickProp,
    ...rest
  } = props
  const onClick = () => {
    if (!isDisabled) {
      onClickProp()
    }
  }
  const enabledOrDisabled = isDisabled
    ? 'disabled'
    : 'enabled'
  return (
    <button
      /**
       * Have to prop spread because popover wraps this in many
       * cases and the tooltip / popover will not work without this (prop forwarding).
      */
      { ...rest }
      className={ `reveleer-control-button ${enabledOrDisabled}` }
      id={ id }
      onClick={ onClick }
    >
      <Icon />
    </button>
  )
}

export default ReveleerControlButton
